import { render, staticRenderFns } from "./LatestFollower.vue?vue&type=template&id=373f360a"
import script from "./LatestFollower.vue?vue&type=script&lang=js"
export * from "./LatestFollower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports